import defaultColor from "@/components/color";
export default {
    cptDataForm:{
        dataText: '[{"username":"张三","sex":"男","age":"18","address":"广东省深圳市南山区粤海街道腾讯大厦"},{"username":"张三","sex":"男","age":"18","address":"广东省深圳市南山区粤海街道腾讯大厦"},{"username":"张三","sex":"男","age":"18","address":"广东省深圳市南山区粤海街道腾讯大厦"},{"username":"张三","sex":"男","age":"18","address":"广东省深圳市南山区粤海街道腾讯大厦"},{"username":"张三","sex":"男","age":"18","address":"广东省深圳市南山区粤海街道腾讯大厦"}]',
        dataSource: 1, pollTime: 0
    },
    interaction:{
        // tableActive:'', // 列或行点击
        // columnclickValue:"",
        // intType:"display",
    },
    attribute:{
        showType: 'table',
        bordered: true,
        pageShow: false,//是否显示自带分页
        textAlign:'center',
        lineHeight:30,
        headLineHeight: 30,
        showIndex: true,
        borderColor: false,
        chooseColor: '#fff',
        theadBg: '#081449',
        theadColor:'#6aa9e4',
        theadSize:14,
        tbodyColor:'#fff',
        tbodySize:13,
        pageSize:5,
        pageSizeOption:'5,10,20,50',
        oddRowBg: 'rgba(0,71,143,0.41)',
        evenRowBg: 'rgba(18,123,251,0.38)',
        chooseRowBg: 'rgba(0,71,143,0.41)',
        pageSelectBorderColor: '',
        pageNumberColor: '#fff',
        headFontFamily: '',
  
        columns:[
            {colKey: 'username', title: '姓名', width: 0,id:'t02'},
            {colKey: 'age', title: '年龄', width: 0,id:'t03'},
            {colKey: 'sex', title: '性别', width: 0,id:'t04'},
            {colKey: 'address', title: '家庭住址',width: 200,id:'t05'}
        ]
    }
}
